'use strict';

angular.module('admin.programme', [
    'ng-komondor-resource-view',
])

.factory('cloneProgrammeAction', function ($http, $state, notify)
{
    return {
        name: 'clone',
        buttonClass: 'btn btn-default',
        template: '<i class="glyphicon glyphicon-duplicate"></i>Clone',
        act: function (models)
        {
            notify.confirm('Are you sure ?').result.then(function ()
            {
                return $http.post('/api/programmes/duplicate', {
                    'id' :  models[0].id,
                }).then(function ()
                {
                    return $state.reload();
                });
            });
        },
        show: function (models)
        {
            return models.length === 1;
        }
    };
})

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.programmes', {
        url: 'programmes',
        model: 'Programme',
        viewOptions: 'programmeViewOptions',
        title: 'Programmes',
        modelNameField: 'title',
        edit: {
            templateUrl: 'admin/programme/programme.edit.html',
            controller: 'ProgrammeAdminCtrl',
            defaults: {
                parent_id: 0,
            }
        },
    });

    resourceStateProvider
        .state('admin.programmes-lang', {
            url: 'programmes/lang/{parentId:[0-9\w-]+}',
            model: 'Programme',
            viewOptions: 'programmeLangViewOptions',
            title: 'Programmes',
            modelNameField: 'title',
            edit: {
                templateUrl: 'admin/programme/programme.lang.html',
                controller: 'ProgrammeAdminLangCtrl',
                defaults: {
                    parent_id: 0,
                }
            },
            root: {
                resolve: {
                    languages: ['Language', function (Language) {
                        return Language.findAll();
                    }],
                    viewOptions: [
                        'programmeLangViewOptions',
                        '$stateParams',
                        'stateOptions',
                        'Model',
                        '$state',
                    function (viewOptions, $stateParams, stateOptions, Model, $state)
                    {
                        //Needs optimization
                        return Model.findAll().then(function ()
                        {
                            var programme = Model.get($stateParams.parentId);

                            if (programme) {

                                var breadcrumb = [];

                                breadcrumb.push({
                                    name: 'Programmes',
                                    go: function ()
                                    {
                                        $state.go('admin.programmes');
                                    }
                                });

                                breadcrumb.push({
                                    name: programme.title += ' - Translations',
                                });

                                stateOptions.customBreadcrumb = breadcrumb;
                                stateOptions.edit.defaults.parent_id = programme.id;
                                viewOptions.queryDefaults.where.parent_id = programme.id;
                            }

                            return viewOptions;
                        });
                    }]
                }
            }
        });
})

.factory('programmeViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    gridThumbTemplate,
    gridNameTemplate,
    $state,
    cloneProgrammeAction
) {
    var options = extendDeep(angular.copy(resourceViewOptions), {
        onItemClick: function ($event, model)
        {
            $state.go('programme', {programmeSlug: model.slug});
        },
        with: [
            'asset',
        ],
        queryDefaults: {
            sort: [['display_order', 'ASC']],
            parent_id: 0
        },
        list: {
            columns: [
                {
                    label: 'Title',
                    name: 'title',
                   // template: listNameTemplate('title', 'asset.links.thumb'),
                    sortable: true,
                },
                {
                    label: 'Type',
                    name: 'type',
                    sortable: false,
                },
                {
                    label: 'Slug',
                    name: 'slug',
                    sortable: true,
                },
                {
                    label: 'Display Order',
                    name: 'display_order',
                    sortable: true,
                },
                {
                    label: 'Translations',
                    template: '<a ui-sref="admin.programmes-lang({parentId: model.id})">Translations</a>',
                    sortable: false,
                },
                {
                    label: 'Categories',
                    template: '<a ui-sref="admin.categories({programmeId: model.id})">Categories</a>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        grid: {
            fields: [
                {
                    template: gridThumbTemplate('asset.links.thumb'),
                },
                {
                    template: gridNameTemplate('title'),
                },
            ],
        },
    });

    options.actions.push(cloneProgrammeAction);

    return options;
})


.factory('programmeLangViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    gridThumbTemplate,
    gridNameTemplate,
    $state
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        onItemClick: function ($event, model)
        {
            $state.go('programme', {programmeSlug: model.slug});
        },
        with: [
            'asset',
            'parent',
            'language',
        ],
        queryDefaults: {
            sort: [['updated_at', 'DESC']],
            where: {
                parent_id: 0
            }
        },
        list: {
            columns: [
                {
                    label: 'Title',
                    name: 'title',
                    //template: listNameTemplate('title', 'asset.links.thumb'),
                    sortable: true,
                },
                {
                    label: 'Language',
                    name: 'language.name',
                    sortable: true,
                },
                {
                    label: 'Categories',
                    template: '<a ui-sref="admin.categories({programmeId: model.id})">Categories</a>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        grid: {
            fields: [
                {
                    template: gridThumbTemplate('asset.links.thumb'),
                },
                {
                    template: gridNameTemplate('title'),
                },
            ],
        },
    });
});
